module.exports = __webpack_public_path__ + "64fe2fda37935b0d76edaef683ad54e6.txt";